module.exports = __webpack_public_path__ + "static/media/2-1.aa945cc7.svg";